import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async (options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.menu.getList, {}, options);
    if (error) return { error, status };
    return content || {};
};
